<mat-form-field>
  <!--  Enter a date range -->
  <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="picker" [disabled]="disabled">
    <input
      matStartDate
      formControlName="start"
      [maskito]="maskOptions"
      [placeholder]="localeSession.getDateFormat()"
      (focus)="typingInInput = true"
      (blur)="typingInInput = false"
    />
    <input
      matEndDate
      formControlName="end"
      [maskito]="maskOptions"
      [placeholder]="localeSession.getDateFormat()"
      (focus)="typingInInput = true"
      (blur)="typingInInput = false"
    />
  </mat-date-range-input>

  <mat-datepicker-toggle [disabled]="disabled" matIconSuffix [for]="picker"></mat-datepicker-toggle>

  <mat-date-range-picker #picker></mat-date-range-picker>

  @if (rangeForm.controls.start.hasError('matStartDateInvalid')) {
    <mat-error>Invalid start date </mat-error>
  }
  @if (rangeForm.controls.end.hasError('matEndDateInvalid')) {
    <mat-error>Invalid end date </mat-error>
  }
</mat-form-field>
